/**
 * Bitmap pixel font for DitherLogo text rendering.
 * Each character is a 7-row × N-column matrix of 0/1 values.
 * Most letters are 5 columns wide; I and space are 1 column.
 *
 * Ported from C# EduFrame.Common.PixelFont
 */

function p(rows: string[]): number[][] {
  return rows.map((row) => [...row].map((c) => +c));
}

export const PIXEL_FONT: Record<string, number[][]> = {
  A: p(['01110', '10001', '10001', '11111', '10001', '10001', '10001']),
  B: p(['11110', '10001', '10001', '11110', '10001', '10001', '11110']),
  C: p(['01110', '10000', '10000', '10000', '10000', '10000', '01110']),
  D: p(['11110', '10001', '10001', '10001', '10001', '10001', '11110']),
  E: p(['11111', '10000', '10000', '11110', '10000', '10000', '11111']),
  F: p(['11111', '10000', '10000', '11110', '10000', '10000', '10000']),
  G: p(['01110', '10000', '10000', '10011', '10001', '10001', '01110']),
  H: p(['10001', '10001', '10001', '11111', '10001', '10001', '10001']),
  I: p(['1', '1', '1', '1', '1', '1', '1']),
  J: p(['00001', '00001', '00001', '00001', '00001', '10001', '01110']),
  K: p(['10001', '10001', '10010', '11100', '10010', '10001', '10001']),
  L: p(['10000', '10000', '10000', '10000', '10000', '10000', '11111']),
  M: p(['10001', '11011', '10101', '10001', '10001', '10001', '10001']),
  N: p(['10001', '11001', '10101', '10011', '10001', '10001', '10001']),
  O: p(['01110', '10001', '10001', '10001', '10001', '10001', '01110']),
  P: p(['11110', '10001', '10001', '11110', '10000', '10000', '10000']),
  Q: p(['01110', '10001', '10001', '10001', '10101', '10011', '01111']),
  R: p(['11110', '10001', '10001', '11110', '10010', '10001', '10001']),
  S: p(['01110', '10001', '10000', '01110', '00001', '10001', '01110']),
  T: p(['11111', '00100', '00100', '00100', '00100', '00100', '00100']),
  U: p(['10001', '10001', '10001', '10001', '10001', '10001', '01110']),
  V: p(['10001', '10001', '10001', '10001', '01010', '01010', '00100']),
  W: p(['10001', '10001', '10001', '10001', '10101', '10101', '01010']),
  X: p(['10001', '10001', '01010', '00100', '01010', '10001', '10001']),
  Y: p(['10001', '10001', '01010', '00100', '00100', '00100', '00100']),
  Z: p(['11111', '00001', '00010', '00100', '01000', '10000', '11111']),
  ' ': p(['0', '0', '0', '0', '0', '0', '0']),
};
